/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Limit_2_ValueInputs */

const en_svc_agents_limit_2_value = /** @type {(inputs: Svc_Agents_Limit_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An agent only reaches the tools and data its task needs.`)
};

const lv_svc_agents_limit_2_value = /** @type {(inputs: Svc_Agents_Limit_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aģents piekļūst tikai tiem rīkiem un datiem, kas vajadzīgi tā uzdevumam.`)
};

/**
* | output |
* | --- |
* | "An agent only reaches the tools and data its task needs." |
*
* @param {Svc_Agents_Limit_2_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_limit_2_value = /** @type {((inputs?: Svc_Agents_Limit_2_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Limit_2_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_limit_2_value(inputs)
	return en_svc_agents_limit_2_value(inputs)
});